<template>
  <div class="mall-postcode-layer">
    <MallHeader :title="'주소 검색'" @back-click="$emit('close')">
      <div slot="right" class="mall-postcode-layer__header-space"></div>
    </MallHeader>
    <div ref="embed" class="mall-postcode-layer__embed"></div>
  </div>
</template>

<script>
import MallHeader from '@/components/new/molecules/MallHeader.vue'

// 카카오 우편번호 서비스 (index.html 의 postcode.v2.js) 를 화면 전체에 띄움
// 기존 배송지 등록(AddressModal)과 같은 방식
export default {
  name: 'MallPostcodeLayer',
  components: {
    MallHeader,
  },
  mounted() {
    if (typeof kakao === 'undefined' || !kakao.Postcode) {
      this.$emit('error')
      return
    }
    new kakao.Postcode({
      // 검색 결과를 고르면 { address, zipCode } 전달
      oncomplete: (data) => {
        this.$emit('select', { address: data.address, zipCode: data.zonecode })
      },
      onclose: () => {
        this.$emit('close')
      },
      width: '100%',
      height: '100%',
    }).embed(this.$refs.embed)
  },
}
</script>

<style scoped>
.mall-postcode-layer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: 100%;
  max-width: 600px;
  flex-direction: column;
  background: #FFF;
  /* 하단 버튼(10) 위, 확인 팝업(1100) 아래 */
  z-index: 1050;
}

/* 제목이 가운데 오도록 뒤로가기 버튼(32px)과 같은 폭 */
.mall-postcode-layer__header-space {
  width: 32px;
}

.mall-postcode-layer__embed {
  flex: 1;
  min-height: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallPostcodeLayer.vue